import { render, staticRenderFns } from "./HistoryDataChart.vue?vue&type=template&id=35373666&scoped=true"
import script from "./HistoryDataChart.vue?vue&type=script&lang=ts"
export * from "./HistoryDataChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35373666",
  null
  
)

export default component.exports